import React, { useState, useEffect } from 'react';
import { confirmUser, generateSubscriptionDetails, resendConfirmationOTP } from '../apiService';

const UserConfirmation = ({
  handleClose,
  confirmationDetails,
  packageDetails,
  formData,
  onConfirm, // Callback to finalize flow (Order Now / Pay Later)
  setConfirmationDetails,
}) => {
  const [otp, setOtp] = useState('');
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isResending, setIsResending] = useState(false);

  useEffect(() => {
    console.log('Received confirmationDetails in modal:', confirmationDetails);
    console.log('Received packageDetails:', packageDetails);
  }, [confirmationDetails, packageDetails]);

  const handleOtpChange = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) setOtp(value); // numeric only
  };

  const handleOtpSubmit = async (e) => {
    e.preventDefault();
    if (otp.length !== 4) {
      setError('OTP must be a 4-digit number.');
      return;
    }

    try {
      setIsLoading(true);
      setError('');
      setSuccessMessage('');

      const updatedDetails = { ...confirmationDetails, confirmation_pin: otp };

      // 1️⃣ Confirm user registration with OTP
      await confirmUser(updatedDetails);

      // 2️⃣ Generate subscription details for callback
      const subscriptionDetails = generateSubscriptionDetails(
        updatedDetails,
        formData,
        packageDetails
      );
      console.log('Generated subscription details:', subscriptionDetails);

      // 3️⃣ Trigger onConfirm callback to handle subscription creation
      if (onConfirm) {
        await onConfirm(updatedDetails);
      }

      handleClose();
    } catch (err) {
      console.error('Error during OTP confirmation or subscription creation:', err);
      setError('Failed to confirm OTP or create subscription. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleResendOtp = async () => {
    try {
      setIsResending(true);
      setError('');
      setSuccessMessage('');

      const result = await resendConfirmationOTP(confirmationDetails.portal_end_customer_id);
      if (result.success) setSuccessMessage(result.message);
      else setError(result.message);
    } catch (err) {
      console.error('Error resending OTP:', err);
      setError('Failed to resend OTP. Please try again.');
    } finally {
      setIsResending(false);
    }
  };

  return (
    <div className="modal show" style={{ display: 'block' }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content text-dark">
          <div className="modal-header" style={{ backgroundColor: '#e2520f', color: 'white' }}>
            <h5 className="modal-title">User Confirmation</h5>
            <button type="button" className="btn-close" onClick={handleClose} disabled={isLoading}></button>
          </div>
          <div className="modal-body" style={{ backgroundColor: '#f8f9fa' }}>
            <p>Please enter the OTP sent to your email or SMS on your phone, to confirm your Package:</p>
            <ul>
              <li><strong>Package:</strong> {packageDetails?.name || 'N/A'}</li>
              <li><strong>Price:</strong> {packageDetails?.price || 'N/A'}</li>
              <li><strong>Speed:</strong> {packageDetails?.speed || 'N/A'}</li>
            </ul>

            {error && <div className="alert alert-danger">{error}</div>}
            {successMessage && <div className="alert alert-success">{successMessage}</div>}

            <form onSubmit={handleOtpSubmit}>
              <div className="mb-3">
                <label htmlFor="otp" className="form-label">OTP</label>
                <input
                  type="text"
                  className="form-control"
                  id="otp"
                  value={otp}
                  onChange={handleOtpChange}
                  maxLength={4}
                />
              </div>
              <button type="submit" className="ftthsa btn-secondary" disabled={isLoading || otp.length !== 4}>
                {isLoading ? 'Processing...' : 'Verify OTP & Confirm Subscription'}
              </button>
            </form>

            <div className="mt-3">
              <button type="button" className="btn btn-link" onClick={handleResendOtp} disabled={isResending || isLoading}>
                {isResending ? 'Resending...' : 'Resend OTP'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserConfirmation;
